<template>
  <v-container class="pa-0 ma-0 d-flex flex-column">
    <!-- Row 1 -->
    <v-row class="ma-0 pa-0">
      <v-col
        v-for="(item, index) in stats"
        :key="index"
        cols="12"
        sm="6"
        md="3"
        :class="['pa-2', index === 0 && 'pr-0', index === row1.length - 1 && 'pl-0']"
      >
        <v-card
          outlined
          :style="getIconName(item.title).bgColor"
          class="stat-cards pa-3 ma-0 d-flex flex-column"
        >
          <!-- title + icon -->
          <v-container class="pa-0 ma-0 d-flex justify-space-between align-center">
            <v-container class="pa-0 ma-0 d-flex flex-column">
              <v-card-text class="pa-0 ma-0 text-body-1">
                {{ item.title }}
              </v-card-text>
              <v-card-text class="pa-0 ma-0 text-body-2">
                {{ item.value }}
                <!-- <span v-if="index == 2"> {{ $store.state.currency.name }}</span> -->
                <span> {{ $t("numbers") }} </span>
              </v-card-text>
            </v-container>

            <v-sheet
              width="35"
              height="35"
              :color="getIconName(item.title).bgIcon"
              class="pa-0 ma-0 d-flex align-center justify-center"
            >
              <my-icon
                :name="getIconName(item.title).name"
                :width="14"
                :height="14"
                :stroke="getIconName(item.title).color"
                :fill="getIconName(item.title).color"
              />
            </v-sheet>
          </v-container>

          <!-- percent -->
          <v-container
            v-if="item.trend != null"
            class="pa-0 ma-0 d-flex align-center mt-2"
          >
            <v-icon size="14" :color="getPercentColor(item.trend)">
              {{ getPercentIcon(item.trend) }}
            </v-icon>

            <v-card-text
              class="pa-0 ma-0 pl-2 text-body-2"
              :style="{ color: getPercentColor(item.trend) }"
            >
              {{ item.percent }}٪
            </v-card-text>

            <v-card-text class="pa-0 ma-0 text-body-2">
              {{ item.compare }}
            </v-card-text>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import MyIcon from "@/views/dashboard/components/general/icon/MyIcon.vue";

export default {
  name: "overviewCRM",
  components: { MyIcon },
  props: {
    taxPayerData: {
      type: Object,
      required: true,
    },
    duration: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    row1() {
      return this.stats.slice(0, 4);
    },
    row2() {
      return this.stats.slice(4, 8);
    },
    stats() {
      return [
        {
          title: this.$t("successful_invoices"),
          value: this.taxPayerData?.current?.success ?? 0,
          percent: Math.abs(this.taxPayerData?.diffPercent?.success ?? 0),
          trend: this.taxPayerData?.trend?.success ?? "none",
          compare: this.duration ? this.$t("duration") : this.$t("month_compare"),
        },
        {
          title: this.$t("pending_invoices"),
          value: this.taxPayerData?.current?.pending ?? 0,
          percent: Math.abs(this.taxPayerData?.diffPercent?.pending ?? 0),
          trend: this.taxPayerData?.trend?.pending ?? "none",
          compare: this.duration ? this.$t("duration") : this.$t("month_compare"),
        },
        {
          title: this.$t("unsent_invoices"),
          value: this.taxPayerData?.current?.not_sent ?? 0,
          percent: Math.abs(this.taxPayerData?.diffPercent?.not_sent ?? 0),
          trend: this.taxPayerData?.trend?.not_sent ?? null,
          compare: this.duration ? this.$t("duration") : this.$t("month_compare"),
        },
        {
          title: this.$t("invoices_with_errors"),
          value: this.taxPayerData?.current?.failed ?? 0,
          percent: Math.abs(this.taxPayerData?.diffPercent?.failed ?? 0),
          trend: this.taxPayerData?.trend?.failed ?? "none",
          compare: this.duration ? this.$t("duration") : this.$t("month_compare"),
        },
      ];
    },
  },
  methods: {
    getIconName(title) {
      const map = {
        [this.$t("successful_invoices")]: {
          name: "tick-icon",
          bgIcon: "#00A63E",
          color: "#fff",
          bgColor: { backgroundColor: "#00c9501b" },
        },
        [this.$t("pending_invoices")]: {
          name: "check-average",
          bgIcon: "#00A63E",
          color: "#fff",
          bgColor: { backgroundColor: "#00c9501b" },
        },
        [this.$t("unsent_invoices")]: {
          name: "not-send-icon",
          bgIcon: "#155DFC",
          color: "#fff",
          bgColor: { backgroundColor: "#2b80ff24" },
        },
        [this.$t("invoices_with_errors")]: {
          name: "circle-alert-outline",
          bgIcon: "#fc151dff",
          color: "#fff",
          bgColor: { backgroundColor: "#ff2b3d24" },
        },
      };

      return (
        map[title] || {
          name: "arrow-up",
          bgIcon: "#9810FA",
          color: "#fff",
          bgColor: { backgroundColor: "#ac46ff48" },
        }
      );
    },
    formatNumber(value) {
      if (value === null || value === undefined) return "-";
      return this.$numberFormat(value);
    },
    getPercentColor(trend) {
      if (trend != null && trend == "increase") {
        return "#008236";
      }
      if (trend != null && trend == "decrease") {
        return "#C10007";
      }
      if (trend != null && trend == "none") {
        return "#a7a4a4ff";
      }
    },
    getPercentIcon(trend) {
      if (trend != null && trend == "increase") {
        return "mdi-arrow-top-right";
      }
      if (trend != null && trend == "decrease") {
        return "mdi-arrow-bottom-right";
      }
      if (trend != null && trend == "none") {
        return "";
      }
    },
  },
};
</script>

<style scoped>
.stat-cards {
  width: 100%;
  min-height: 90px;
  border-radius: 12px !important;
  border: 1px solid #f3f4f6;
  backdrop-filter: blur(5px);
}
</style>
